<div style="display: flex; justify-content: space-between; width: 280px">
  <mat-form-field
    appearance="outline"
    class="time-picker-box mt-2"
    style="width: 75px"
  >
    <mat-select
      [placeholder]="'HH'"
      [formControl]="hourControl"
      (blur)="onBlurEvent($event)"
      fill="outline"
    >
      <mat-option *ngFor="let elm of hrsPptions" [value]="elm">
        {{ elm }}
      </mat-option>
    </mat-select>
    <mat-icon *ngIf="!hasError()" color="primary" matSuffix
      >arrow_drop_down</mat-icon
    >
    <!-- <mat-error *ngIf="hasError()">{{ getErrorMessage() }}</mat-error> -->
  </mat-form-field>
  <strong class="mt-3">:</strong>
  <mat-form-field
    appearance="outline"
    class="time-picker-box mt-2"
    style="width: 75px"
  >
    <mat-select
      [placeholder]="'MM'"
      [formControl]="minControl"
      (blur)="onBlurEvent($event)"
      fill="outline"
    >
      <mat-option *ngFor="let elm of minPptions" [value]="elm">
        {{ elm }}
      </mat-option>
    </mat-select>
    <mat-icon *ngIf="!hasError()" color="primary" matSuffix
      >arrow_drop_down</mat-icon
    >
  </mat-form-field>
  <strong class="mt-3">:</strong>
  <mat-form-field
    appearance="outline"
    style="width: 90px"
    class="time-picker-box mt-2"
  >
    <mat-select
      [placeholder]="'AM/PM'"
      [formControl]="meridianControl"
      (blur)="onBlurEvent($event)"
      fill="outline"
      class="time-picker-options"
    >
      <mat-option  *ngFor="let elm of meridianPptions" [value]="elm" class="time-picker-options">
        {{ elm }}
      </mat-option>
    </mat-select>
    <mat-icon *ngIf="!hasError()" color="primary" matSuffix >arrow_drop_down</mat-icon>
    <!-- <mat-error *ngIf="hasError()">{{ getErrorMessage() }}</mat-error> -->
  </mat-form-field>
  <div class="mt-3">
    <mat-icon *ngIf="hasError()" matSuffix color="warn">info</mat-icon>
    <!-- <mat-icon *ngIf="(isValid() && isOptional() && isTouched()) || (isValid() && !isOptional())" matSuffix class="icon-success">check_circle</mat-icon> -->
    <mat-icon *ngIf="!hasError()" style="cursor: pointer; margin-left: 5px; padding: 0px !important;"  matSuffix class="clear-filter-icon" (click)="clearFilter($event)">clear</mat-icon>
  </div>
</div>
